<template>
    <a class="user-link" :href="`/user/?id=${ id }`" target="_blank">
        <slot>{{ name }}</slot>
    </a>
</template>

<script>
export default {
    props: {
        name: String,
        id: {}
    }
}
</script>

<style>

</style>